<template>
  <div id="integrations">
    <div>
      <mu-card-header
        titleClass="boldTitle largeTitle"
        :title="title"
        :subTitle="subTitle"
      ></mu-card-header>
      <mu-card-text class="integration-panel">
        <mu-row gutter v-for="integration, index in integrations" :key="'integration-' + index"
                v-bind:class="{ bottom }" class="integration-item">
          <mu-col width="100" desktop="10" tablet="10" style="position:relative">
            <img :src="integration.image" width="100%"/>
            <div style="position:absolute" class="check">
              <mu-icon color="white" value="check"></mu-icon>
            </div>
          </mu-col>
          <mu-col width="100" desktop="90" tablet="90">
            <div class="title" v-text="integration.title"></div>
            <div class="afterText" v-text="integration.description"></div>
            <div v-if="!subscribedTo(integration.key)">
              <mu-raised-button
                :label="$t('message.connectText')"
                @click.native="windowOpen(integration.url, integration.key, integration.cookie, integration.handshake)"
              ></mu-raised-button>

            </div>
            <div v-else>
              <mu-raised-button
                background-color="red"
                color="white"
                :label="$t('message.disconnectText')"
                @click.native="disconnectIntegration(integration.key)"
              >
              </mu-raised-button>
              <mu-raised-button
                :disabled="hasStriivSyncStarted || isStriivPending || isStriivPending"
                v-if="integration.syncsHeartRate"
                :label="isStriivPending === true ? 'Sync is already processing' : 'Sync readings'"
                @click.native="syncStriivHeartRate"></mu-raised-button>
            </div>
          </mu-col>
        </mu-row>
      </mu-card-text>
    </div>
  </div>
</template>
<script>


  import config from '../../config'
  import axios from 'axios'
  import IntegrationApi from '../../api/Integrations'


  export default {
    data() {
      return {
        title: this.$t('message.integrationPreferencesTitle'),
        subTitle: this.$t('message.integrationPreferencesSubTitle'),
        isUpdating: false,
        isLoading: true,
        subscriptions: [],
        canStriivSync: false,
        hasStriivSyncStarted: false,
        integrations: [
          {
            key: "FITBIT",
            title: 'FitBit',
            image: "static/integrations/fitbit.svg",
            description: this.$t('message.integrationFitBitExplain'),
            url: config.apiUrl + "integration/fitbit/auth/",
            cookie: "FITBIT_REDIRECT_URI",
            handshake: IntegrationApi.FITBIT.generateHandshake
          },
          /*{
            key: 'STRIIV',
            title: 'Striiv',
            image: 'static/integrations/striiv.png',
            description: this.$t('message.integrationStriivExplain'),
            supportedFeatures: [
              'HEARTRATE'
            ],
            url: config.apiUrl + "integration/striiv/auth/",
            syncsHeartRate: true,
            isStriivPending: false
          }*/
        ]
      }
    },
    mounted() {
      let self = this;
      self.getSubscriptions();
    },
    methods: {
      getSubscriptions() {
        let self = this;
        IntegrationApi.getSubscriptions()
          .then(function (response) {
            self.subscriptions = response.data;
            self.subscriptions.forEach(function (item) {

              /**
               if (item === 'STRIIV') {
              axios.get(config.apiUrl + 'integration/striiv/heartRate/lastSyncTime')
                .then(function (response) {
                  self.canStriivSync = true;
                  self.isStriivPending = response.data.internalSync.status === 'PENDING';
                })
            }
               **/
            })
          })
      },

      disconnectIntegration(key) {
        let self = this;
        IntegrationApi.disconnectIntegration(key)
          .then(function (response) {
            self.getSubscriptions();
          });
      },
      /**
       syncStriivHeartRate() {
        let self = this;
        axios.get(config.apiUrl + 'integration/striiv/sync/heartrate')
          .then(function (response) {
            if (response.data.started) {
              self.$toastr.success(this.$t('message.integrationStriivImportStarted'));
              self.hasStriivSyncStarted = true;
            }
            else {
              self.$toastr.error(this.$('message.integrationStriivImportEmpty'));
              self.hasStriivSyncStarted = false;
            }

          })
      },
       **/
      windowOpen(url, key, cookie, handshake) {
        let self = this;
        let value = '';
        if (handshake && typeof handshake === 'function') {
          handshake().then((response)=> {
            const uuid = response.data.uuid;
            if (!uuid || !uuid.length) {
              throw "Invalid response";
            }
            url = `${url}?uuid=${uuid}`;
            setLocation();
          });
        } else {
          setLocation();
        }

        const setLocation = () => {
          if (config.ApplicationContext === 'lowcarbprogram') {
            value = "https://www.lowcarbprogram.com/" + config.locale + "/#/integrated?name=" + key;
          } else {
            value = "https://www.grohealth.com/" + config.locale + "/#/integrated?name=" + key;
          }
          self.setCookie(cookie, value, 1);
          window.location.href = url;
        };
      },
      setCookie(name, value, days) {
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
      },
      subscribedTo(key) {
        let self = this;
        let found = self.subscriptions.indexOf(key);
        return found !== -1;
      }
    }
  }
</script>
<style lang="less">
  #integrations {
    .row.integration-item {
      margin-bottom: 16px;
    }
    .row.integration-item:last-child {
      margin-bottom: 0px;
    }
    .bottom {
      margin-bottom: 16px;
    }
    .title {
      font-size: 18px;
    }
    .afterText {
      margin-bottom: 8px;
    }
    .check {
      position: absolute;
      bottom: 0px;
      background: #99ca40;
      vertical-align: middle;
      align-items: center;
      display: flex;
      border-radius: 50%;
    }
  }
</style>



// WEBPACK FOOTER //
// Integrations.vue?54de9dd2